export const merchantMessagesGetters = {
  merchantMessages: (state) => state.merchantMessages,
  showThread: (state) => state.showThread,
  showConv: (state) => state.showConv,
  fullName: (state) => state.fullName,
};
